import { DocMeta } from "../App";
import { DocListTab } from "./DocListTab";

interface ListsTabProps {
  onOpenList: (doc: DocMeta) => void;
  syncVersion?: number;
}

export function ListsTab({ onOpenList, syncVersion }: ListsTabProps) {
  return (
    <DocListTab
      docType="list"
      title="Lists"
      onOpen={onOpenList}
      syncVersion={syncVersion}
    />
  );
}
